import { useQuery } from '@tanstack/react-query';
import { getMainCompanies } from 'api/companyContext';
import { companiesKeys } from 'api/queryKeys';

export const useMainCompaniesQuery = (enabled = true) => {
  return useQuery({
    queryKey: companiesKeys.mainList(),
    queryFn: () => getMainCompanies().then((res) => res.data ?? []),
    enabled
  });
};
